module.exports = __webpack_public_path__ + "static/media/thompson_jersey.cd906a9e.jpg";